export default [
    {
        path: 'reabertura-viagem',
        component: () => import(
            '@/views/transporte-paciente/reabertura-viagem/Index'
        ),
        redirect: 'reabertura-viagem/list',
        children: [
            {
                name: 'transporte-paciente-reabertura-viagem-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/reabertura-viagem/List'
                ),
            },
        ],
    },
]